module.exports = __webpack_public_path__ + "media/components/PulseBackports/Avatar/profile-pic-upload-34095f6a8695e6c8001ceed06864f433.svg";